import qs from 'qs';

export const FAQ_CATEGORIES = {
  GENERAL_QUERIES: "general_queries"
}

export const getAllFaqCategoriesQs = qs.stringify({
  populate: {
    icon: {
      fields: ['url', 'alternativeText']
    }
  }
})

export const getAllFaqsQs = (cipVersionType) => qs.stringify({
  filters: {
    cipCrpType: {
      cipVersionType: { $in: [cipVersionType] }
    }
  },
  populate: {
    faqCategory: {
      fields: ['title', 'slug']
    }
  },
  pagination: {
    pageSize: 1000
  }
})


export const getFaqFromCategoryQs = (categorySlug = FAQ_CATEGORIES.GENERAL_QUERIES, cipVersionType) => {
  return qs.stringify({
    filters: {
      faqCategory: {
        slug: { $eq: categorySlug }
      },
      cipCrpType: {
        cipVersionType: { $in: [cipVersionType] }
      }
    },
    pagination: {
      pageSize: 1000
    }
  })
}
export const getSpecificFaqQs = (categorySlug = FAQ_CATEGORIES.GENERAL_QUERIES, questionSlug) => {
  return qs.stringify({
    filters: {
      faqCategory: {
        slug: { $eq: categorySlug }
      },
      slug: {
        $eq: questionSlug
      }
    },
    pagination: {
      pageSize: 1000
    }
  })
}

export const getFaqCategoryInfo = (categorySlug) => {
  return qs.stringify({
    filters: {
      slug: { $eq: categorySlug }
    },
    populate: {
      mainPageIcon: {
        fields: ['url', 'alternativeText']
      }
    }
  })
}

export const getPopularArticlesQs = qs.stringify({
  populate: {
    popular_articles: {
      fields: ['question', 'slug'],
      populate: {
        faqCategory: {
          fields: ['slug']
        },
        cipCrpType: {
          fields: ['cipVersionType']
        }
      }
    }
  },
  pagination: {
    pageSize: 1000
  }
})
